
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'BladderTumor_TNM',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/BladderTumor_TNM.vue